import { Button, ButtonGroup } from "@blueprintjs/core";
import HeadingView from "common/views/heading/Heading.view";
import PagingView from "common/views/paging/Paging.view";
import { Fragment } from "core/components/FragmentProvider";
import KbLabels from "../Kb.labels";
import * as parentContainerFragments from "./container/parentContainerFragments";
import { IKbMetaProps } from "./IKbMetaProps";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import Label from "core/components/label/Label";

// the results list element
export const results: Fragment<IKbMetaProps> = {
	name: "Article Results List",
	component: ({ resultsElement }) => {
		console.log(resultsElement);
		return resultsElement;
	} // function instead of an element because this gets registered. We need it to update. Remove registration from fragment provider?
};

// title
export const title: Fragment<IKbMetaProps> = {
	name: "Title",
	component: () => (
		<HeadingView viewKey="article.title" autoSkeleton={false}>
			<KbLabels.Labels.PanelTitle />
		</HeadingView>
	)
};

// description
export const description: Fragment<IKbMetaProps> = {
	name: "Description",
	component: () => (
		<HeadingView viewKey="article.description" autoSkeleton={false}>
			<KbLabels.Labels.PanelDescription />
		</HeadingView>
	)
};

// result info "1 of 2 result(s)"
export const resultInfo: Fragment<IKbMetaProps> = {
	name: "Result(s) Info",
	component: ({
		loading,
		queryMeta: { count, pageNumber, pageSize, total }
	}) => {
		const start = pageNumber * pageSize;
		const end = start + count;

		let label: JSX.Element;

		label =
			(loading && (
				<KbLabels.Labels.ResultMetaLoading
					args={{
						count,
						start: start + 1,
						end: pageSize
					}}
				/>
			)) ||
			(count > 0 && (
				<KbLabels.Labels.ResultMeta
					args={{ start: start + 1, end, total }}
				/>
			));

		return (
			<HeadingView viewKey="article.description" autoSkeleton={false}>
				{label || null}
			</HeadingView>
		);
	}
};

// result info "1 of 2 result(s)"
export const containerPicker: Fragment<IKbMetaProps> = {
	name: "Container View Select",
	component: ({ viewOptions }) => (
		<ButtonGroup>
			{Object.entries(parentContainerFragments).map(([key, fragment]) => (
				<Button
					key={key}
					disabled={viewOptions.container === key}
					onClick={() => viewOptions.setContainer(key)}
				>
					{fragment.name}
				</Button>
			))}
		</ButtonGroup>
	)
};

export const paging: Fragment<IKbMetaProps> = {
	name: "Paging",
	component: ({ queryMeta, setParams }) => (
		<PagingView
			viewKey="article.paging"
			total={queryMeta.total}
			pageSize={queryMeta.pageSize}
			pageNumber={queryMeta.pageNumber}
			setPageNumber={pageNumber => setParams({ pageNumber } as any)}
		/>
	)
};

export const loadMore: Fragment<IKbMetaProps> = {
	name: "Load More",

	component: ({ queryMeta, setParams }) => {
		return (
			<ButtonView
				variant={ButtonVariant.PRIMARY}
				viewKey="article.loadMore"
				onClick={() =>
					setParams({
						pageNumber: queryMeta.pageNumber + 1
					})
				}
			>
				<Label k="article.label.loadMore" v="loadMore" />
			</ButtonView>
		);
	}
};



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/fragments/generalFragments.tsx